<template>
  <div class="x-bar">
    <div :id="id"  :option="option"></div>
  </div>
</template>
<script>
  import Highcharts from 'highcharts';
  import HighchartsMore from 'highcharts/highcharts-more';
  import HighchartsDrilldown from 'highcharts/modules/drilldown';
  import HighchartsNetworkgraph from 'highcharts/modules/networkgraph';
  import HighchartsExporting from 'highcharts/modules/exporting';
  import Highcharts3D from 'highcharts/highcharts-3d';
  import HighchartsOldie from 'highcharts/modules/oldie';
  // import HighchartsDarkUnica from 'highcharts/themes/dark-unica';
  HighchartsMore(Highcharts)
  HighchartsDrilldown(Highcharts);
  Highcharts3D(Highcharts);
  HighchartsNetworkgraph(Highcharts);
  HighchartsExporting(Highcharts);
  HighchartsOldie(Highcharts);
  // HighchartsDarkUnica(Highcharts);
  export default {
    // 验证类型
    props: {
      id: {
        type: String
      },
      option: {
        type: Object
      }
    },
    watch: {
      option () {
        Highcharts.chart(this.id,this.option);
      }
    },
    mounted() {
      Highcharts.chart(this.id,this.option)
    }
  }
</script>

<style lang="scss" scoped>
  .x-bar {
    div {
      height: 736px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/highCharts.vue